<script>
import * as Config from '../config.json';

export let title;
export let logo;
export let isMain;
</script>

<div class="fixed inset-x-0 top-0 flex h-20 z-[1000] px-20 header" class:main={isMain}>
  <div class="flex items-center justify-between flex-1">
    <a target={Config.logoLink ? '_blank' : '_self'} href={Config.logoLink || "/"}>
      <div class="flex items-center cursor-pointer">
        <div class="flex logo-box-mobile">
          <!-- svelte-ignore a11y-missing-attribute -->
          <img src={logo} class='logo' />
          <!-- <div class="logo logo-mobile-small" style="background-position: center;background-image: url({logo})" /> -->
        </div>
        <div class="name">{@html title}</div>
      </div>
    </a>

    <slot />
  </div>
</div>

<style lang='scss'>
@import '../util';

$headerHeight: 5rem;
.header {
  height: $headerHeight;
  background-color: var(--primary);
  color: var(--text-primary);

  @include tablet {
    padding: 0 16px;
  }
}

.main {
  padding:0 5rem 0 10.5rem;

  @include tablet {
    padding: 0 0 0 16px;
  }
}

.logo {
  object-fit: contain;
  // background: url('/img/logo.png');
  // background-size: contain;
  // background-repeat: no-repeat;

  height: calc($headerHeight - 42px);
  // width: 180px;
}

.logo-mobile-small {
  @include landscape {
    // background-image: url('/img/logo-sm.png');
    width: 72px;
    background-size: 90%;
  }
}

.logo-box-mobile {
  @include landscape {
    padding-right: 12px;
  }
}

.name {
  margin-left: 16px;
  font-weight: 900;
  font-size: 20px;
}
</style>